import logo6Bios from '@/assets/images/svgs/logo-6bios.svg'

import { ActiveLink } from '../active-link/active-link'

export function BigFooter() {
  return (
    <div className="bg-bios-neutral-100 px-5 py-5 2xl:px-24">
      <div className="grid grid-cols-1 gap-8 border-t border-bios-600 py-12 xl:grid-cols-10 xl:px-24 2xl:gap-16 2xl:py-24">
        <img
          src={logo6Bios}
          alt=""
          className="mx-auto h-16 w-16 mix-blend-multiply 2xl:h-20 2xl:w-20"
        />
        <div className="flex items-center justify-center text-center xl:col-span-5 xl:text-start">
          <p className="text-xl text-zinc-500">
            Realizamos o monitoramento, captação e distribuição de capital
            global para conservação dos seis biomas brasileiros.
          </p>
        </div>

        <div className="grid grid-cols-2 gap-3 text-center sm:grid-cols-3 sm:grid-rows-2 xl:col-span-4 xl:text-start">
          <ActiveLink to="/about">Quem somos</ActiveLink>
          <ActiveLink to="/technologies">Tecnologias</ActiveLink>

          <ActiveLink to="/services">Serviços</ActiveLink>
          <ActiveLink to="/publications">Publicações</ActiveLink>

          <ActiveLink to="/contact">Contato</ActiveLink>
        </div>
      </div>
    </div>
  )
}
